import { Link } from 'react-router-dom';
import type { GalleryItem } from '../lib/api';
import { VerifiedBadge } from './VerifiedBadge';

/**
 * Free Original Card — a published work, proof baked in, not for sale. Lighter
 * than a Drop Card: image hero, creator handle, a quiet "View Original" link
 * (no Collect CTA, no price, no edition), and the verified mark beneath. See
 * BRAND.md ▸ Brand System ▸ Free Original Card.
 */
export function OriginalCard({ item }: { item: GalleryItem }) {
  const handle = item.creator_x_handle || item.twitterHandle || item.displayName || null;

  return (
    <article className="group flex flex-col overflow-hidden rounded-xl border border-provny-border bg-provny-surface dark:border-provny-border-dark dark:bg-provny-surface-dark">
      <div className="relative block aspect-[4/5] overflow-hidden">
        <img
          src={item.imageUrl}
          alt={handle ? `Original by @${handle}` : 'Original'}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
        />
      </div>

      <div className="flex flex-1 flex-col gap-3 p-4">
        {handle ? (
          <Link
            to={`/@${handle}`}
            className="text-sm text-provny-muted transition-colors hover:text-provny-black dark:hover:text-provny-white"
          >
            @{handle}
          </Link>
        ) : (
          <span className="text-sm text-provny-muted">Anonymous</span>
        )}

        <div className="flex items-center justify-between">
          <Link
            to={`/original/${item.publicMemeId}`}
            className="text-sm font-semibold text-provny-cyber-dim transition-colors hover:underline dark:text-provny-cyber"
          >
            View Original
          </Link>
        </div>

        <div className="mt-auto pt-1">
          <VerifiedBadge geneId={item.publicMemeId} />
        </div>
      </div>
    </article>
  );
}
